var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9989 10.729C31.8897 10.8235 31.7146 11.0137 31.5164 11.3636L8.29969 52.3646C8.06527 52.7785 8.01049 53.05 8.00157 53.1714C8.00153 53.1719 8.0015 53.1724 8.00147 53.1729C8.11451 53.2349 8.38452 53.334 8.9411 53.334H55.0596C55.6166 53.334 55.8862 53.2341 55.9986 53.1721C55.9986 53.1716 55.9986 53.1711 55.9985 53.1706C55.9898 53.0501 55.9354 52.7791 55.7008 52.3647L32.4817 11.3637C32.2836 11.0138 32.1083 10.8235 31.9989 10.729ZM56.0667 53.1238C56.067 53.1241 56.064 53.1276 56.0569 53.1335C56.0629 53.1265 56.0665 53.1235 56.0667 53.1238ZM7.9324 53.1241C7.93268 53.1238 7.93636 53.1269 7.94265 53.1342C7.93526 53.128 7.93212 53.1244 7.9324 53.1241ZM32.001 5.33398C34.3287 5.33504 36.0805 6.89537 37.1226 8.73559L60.3416 49.7365C61.4045 51.6134 61.7962 53.9248 60.5991 55.9218C59.4131 57.9005 57.2055 58.6673 55.0596 58.6673H8.9411C6.79165 58.6673 4.58234 57.8997 3.39758 55.9177C2.20332 53.9198 2.59815 51.6096 3.65874 49.7366L26.8755 8.73568C27.9189 6.89304 29.6721 5.33293 32.001 5.33398Z",
    fill: "#DE3121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 49.3333C33.4727 49.3333 34.6666 48.1394 34.6666 46.6667C34.6666 45.1939 33.4727 44 31.9999 44C30.5272 44 29.3333 45.1939 29.3333 46.6667C29.3333 48.1394 30.5272 49.3333 31.9999 49.3333Z",
    fill: "#DE3121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 22.668C33.4727 22.668 34.6666 23.8619 34.6666 25.3346V38.668C34.6666 40.1407 33.4727 41.3346 31.9999 41.3346C30.5272 41.3346 29.3333 40.1407 29.3333 38.668V25.3346C29.3333 23.8619 30.5272 22.668 31.9999 22.668Z",
    fill: "#DE3121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.28a604a8.svg";
export { ForwardRef as ReactComponent };